import gql from 'graphql-tag';

/**
 * Mutation to restore a previously hidden inspection template so it is
 * visible to a building's inspectors again.
 */
export const unhideInspectionTemplateMutation = gql`
  mutation UnhideInspectionTemplate($input: UnhideInspectionTemplateInput!) {
    unhideInspectionTemplate(input: $input) {
      success
      newVersion
    }
  }
`;
